<template>
  <v-container class="users mx-auto">
    <v-card>
      <v-card-title>Usuários</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              v-model="filter"
              label="Buscar usuários"
              prepend-icon="mdi-magnify"
              @keyup.enter="handleFilter()"
              :disabled="loading"
            ></v-text-field>
          </v-col>
          <v-col class="d-none d-sm-flex align-center justify-end">
            <v-btn icon @click="getUsers()">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn @click="handleClickNewUser" color="red" dark
              >Novo usuário</v-btn
            >
          </v-col>
        </v-row>
        <core-table
          :filter="filter"
          :headers="headers"
          sort-by="name"
          index-url="/users"
          ref="table"
        >
          <template v-slot:item.name="{ item }">
            <a @click="handleClickEditUser(item.id)">{{ item.name }}</a>
          </template>
          <template v-slot:item.avatar_url="{ item }">
            <v-avatar color="primary" size="40">
              <img
                :src="item.avatar_url"
                :alt="item.name"
                v-if="item.avatar_url"
              />
              <v-icon v-else class="white--text">mdi-account-circle</v-icon>
            </v-avatar>
          </template>
          <template v-slot:item.is_admin="{ item }">
            <v-chip
              v-if="item.is_admin"
              color="orange"
              text-color="white"
              small
            >
              <v-icon small left>mdi-star</v-icon>
              Administrador
            </v-chip>
            <v-chip small v-else>
              <v-icon small left>mdi-account</v-icon> Vendedor</v-chip
            >
          </template>
          <template v-slot:item.role_name="{ item }">
            <role-chip
              :role="{
                name: item.role_name,
                description: item.role_description
              }"
            ></role-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn @click="handleClickEditUser(item.id)" icon>
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn @click="handleClickDelete(item.id)" icon>
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </template>
        </core-table>
      </v-card-text>
    </v-card>

    <v-btn
      @click="handleClickNewUser"
      color="red"
      dark
      fab
      fixed
      bottom
      right
      class="d-sm-none"
    >
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="dialog" width="600px" persistent>
      <user-form
        @cancel="handleCloseDialog"
        @submit="handleSubmitForm"
        :id="selected_id"
      ></user-form>
    </v-dialog>

    <v-dialog v-model="confirmation" width="300px">
      <v-card>
        <v-card-title class="headline">Tem certeza?</v-card-title>

        <v-card-text>O usuário será permanentemente excluído</v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="secondary"
            text
            @click="confirmation = false"
            :disabled="delete_loading"
            >Não</v-btn
          >

          <v-btn
            color="primary"
            text
            @click="confirmDelete()"
            :loading="delete_loading"
            >Sim</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import UserForm from "../components/forms/UserForm";
import RoleChip from "../components/forms/RoleChip";

import CoreTable from "../components/CoreTable.vue";

export default {
  name: "users",
  components: { UserForm, RoleChip, CoreTable },
  data: () => ({
    dialog: false,
    filter: "",
    loading: false,
    headers: [
      {
        text: "",
        value: "avatar_url",
        sortable: false,
        align: "center",
        width: 70
      },
      {
        text: "Nome",
        value: "name"
      },
      {
        text: "Tipo",
        value: "is_admin"
      },
      {
        text: "Email",
        value: "email"
      },
      { text: "Ações", value: "actions", sortable: false }
    ],
    users: [],
    totalUsers: 0,
    options: {
      itemsPerPage: 10,
      sortBy: ["name"]
    },
    selected_id: null,
    confirmation: false,
    delete_loading: false
  }),
  methods: {
    handleFilter() {
      this.$refs.table.getItems();
    },
    indexUsers() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      return this.$http.get(
        `/users?&page=${page}&perPage=${itemsPerPage}&orderBy=${
          sortBy[0] ? sortBy[0] : ""
        }&sortDesc=${sortDesc[0] ? sortDesc[0] : ""}&filter=${this.filter}`
      );
    },
    async getUsers() {
      this.$refs.table.getItems();
    },
    deleteUser(id) {
      return this.$http.delete(`/users/${id}`);
    },
    handleClickNewUser() {
      this.selected_id = null;
      this.dialog = true;
    },
    handleSubmitForm() {
      this.selected_id = null;
      this.dialog = false;
      this.getUsers();
    },
    handleClickEditUser(id) {
      this.selected_id = id;
      this.dialog = true;
    },
    handleCloseDialog() {
      this.selected_id = null;
      this.dialog = false;
    },
    handleClickDelete(user_id) {
      this.confirmation = true;
      this.selected_id = user_id;
    },
    async confirmDelete() {
      this.delete_loading = true;
      try {
        await this.deleteUser(this.selected_id);
        this.confirmation = false;
        this.getUsers();
        this.$store.commit("sendMessage", {
          text: "Usuário excluído com sucesso!"
        });
      } catch (e) {
        this.$store.commit("sendMessage", {
          text: message
        });
      } finally {
        this.delete_loading = false;
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.getUsers();
      },
      deep: true
    }
  }
};
</script>

<style lang="scss">
.users {
  margin-bottom: 100px;
}
</style>
